<template>
  <div class="modal-wrapper">
    <modal
      name="terms-and-conditions"
      height="auto"
      :scrollable="false"
      :clickToClose="!blocking"
      :adaptive="true"
    >
      <div class="modal-content" style="height: 85vh">
        <div class="modal-header">
          <h4 class="modal-title">{{ $t('register.modal.terms-of-use-title') }}</h4>

          <button
            v-if="!blocking"
            class="close"
            type="button"
            data-dismiss="modal"
            aria-label="Close"
            @click="$modal.hide('terms-and-conditions')"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <div
          class="modal-body"
          style="overflow-y: auto"
          v-html="$t('register.modal.terms')"
        ></div>

        <div class="modal-footer">
          <button
            class="btn btn-secondary"
            style="white-space: normal"
            type="button"
            :disabled="loading"
            @click="btnClick"
          >
            {{ btnText }}
          </button>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import api from '@/api'
import message from '@/message'

export default {
  name: 'Terms',

  data() {
    return {
      loading: false
    }
  },

  computed: {
    btnText() {
      return this.blocking ? this.$t('modal.accept') : this.$t('modal.close')
    },
    blocking() {
      return this.$store.state.request_terms
    }
  },

  watch: {
    blocking(newValue) {
      if (newValue) {
        this.$modal.show('terms-and-conditions')
      } else {
        this.$modal.hide('terms-and-conditions')
      }
    }
  },

  methods: {
    btnClick() {
      if (!this.blocking) {
        this.$modal.hide('terms-and-conditions')
        return
      }

      this.loading = true
      api.post('/terms-of-use-consent/')
        .then(() => {
          this.$store.commit('SET_REQUEST_TERMS', false)
        })
        .catch(() => {
          message.error(this.$t('modal.terms-error'))
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Terms.vue